import { app } from "../../config"
import localstorage from "../localstorage";
import store from "../store"

// Função assíncrona para obter o IP do usuário

// Interceptor para adicionar o IP do usuário e outros cabeçalhos em todas as solicitações
export default async (request, next) => {
	try {
		// Obter o IP do usuário antes de continuar com a solicitação

		// Adicionar os cabeçalhos à solicitação
		request.headers.set("Accept", "application/json")
		request.headers.set("Content-Type", "application/json")
		request.headers.set("Content-Language", app.locale)

		let localStorageToken = await localstorage.getItem(app.userTokenStorageKey);

		if (store.getters["Auth/getToken"] && localStorageToken && store.getters["Auth/getToken"] !== localStorageToken) {
			await store.dispatch("Auth/setToken", localstorage.getItem(app.userTokenStorageKey))
			window.location.reload()
		}
	} catch (error) {
		console.error("Erro ao configurar os cabeçalhos da solicitação:", error)
	}

	// Continuar com a solicitação
	next()
}
